module.exports = "/static/assets/06caa78236d13412a329a8a58b8e2365.png";